<template>
  <div class="w-full h-full flex items-center justify-center theme-background-default dark:theme-background-default-dark">
    <OrLoaderV3
      variant="linear"
      color="primary"
      :title="$t('activity.AppLoaderTitle')"
      :description="$t('activity.AppLoaderDescription')"
      class="w-[432px] mx-sm"
    />
  </div>
</template>

<script setup lang="ts">
import { OrLoaderV3 } from '@onereach/ui-components';
</script>
